/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.MiscSupplyDefinitions {
    "use strict";

    export class MiscSupplyDefinitionsContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            timeoutService: angular.ITimeoutService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);
        }

        initializeContext(): void {
            this.baseEndpoint = this.appSettings.API_ENDPOINTS.miscSupplyDefinitions;
            this.sectionTemplatePath = "app/plugins/miscSupplyDefinitions/sectionViews/";
            this.buildCrudSecurityKeys(this.securityKeys.INVENTORY_MISCSUPPLYDEFINITIONS_TAB_MAIN);
        }

        initializeSections(): void {
            this.initializeContext();
           if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INVENTORY_MISCSUPPLYDEFINITIONS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0,
                    "SECTION_MAIN",
                    "main.html",
                    true,
                    false,
                    this.baseEndpoint,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.MiscellaneousSupplyMain,
                    this.modalService,
                    this.securityKeys.INVENTORY_MISCSUPPLYDEFINITIONS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                ));
          }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
        }

        undelete(): void {
            super.undelete(true);
            // When a Misc Product is deleted both the product object state and the variant object state are changed
            // This line below ensures that we revert the object state of variant back to Active when we Undelete the Misc Product
            this.selectedSection.model["variants"][0].objectState = Meevo.Model.ObjectStateEnum.Active;
        }

        addFloorLocation(variant: Model.Variant): void {
            if (!variant.floorLocation) return;

            if (variant.floorLocations.some(fl => fl.id === variant.floorLocation.id)) return;

            variant.floorLocations.push(variant.floorLocation);
            variant.floorLocation = null;
        }

        removeFloorLocation(variant: Model.Variant, index: number): void {
            if (index >= 0) {
                variant.floorLocations.splice(index, 1);
            }
        }

        // Variants object state must be modified when the object is discontinued
        processDiscontinued = (variant: any) => {
            if (variant.isDiscontinued)
                variant.objectState = Meevo.Model.ObjectStateEnum.Inactive;
            else
                variant.objectState = Meevo.Model.ObjectStateEnum.Active;
        }

        // Initialize Variants object state
        amIDiscountinued = (variant: any) => {
            if (variant) {
                if (variant.objectState == Meevo.Model.ObjectStateEnum.Inactive)
                    variant.isDiscontinued = true;
                else
                    variant.isDiscontinued = false;
            }
        }

        /*
        get showDelete(): boolean {
            return false;
        }*/
    }
}